
















const ExcelJS = require("exceljs");

import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import StatusSummarySearch from "@/components/report/StatusSummarySearch.vue";
import ListView from "@/components/report/StatusSummaryList.vue";
import { GapStatusSummaryReportFilter} from "@/store/modules/types";
//import App from "@/App.vue";
import { getDate } from '@/services/timezone';

@Component({
  components: {
    BPagination,
    Header,
    EntityTabs,
    StatusSummarySearch,
    ListView,
  },
  computed: {
    ...mapState("gaps", ["filter"]),
  },
})
export default class StatusSummaryReport extends Vue {
  //period: string = "M";
  //filter!: this.defaultFilter();
  getDate = getDate;
  reportFilter = this.defaultFilter();
  header: any = {};
  pageRows: Array<any> = [];
  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.reportFilter = this.defaultFilter();
    this.getReport();
  }

  defaultFilter(): GapStatusSummaryReportFilter {
    return {
      period: "M",
      campaignId:null,
      createdDate: {
        from: null,
        to: null
      },
       logDate: {
        from: null,
        to: null
      },
      reportByLog:false
    };
  }

 

  async getReport() {
    this.pageRows = [];
    if (!this.reportFilter.period) {
      return;
    }

    this.$store.commit("main/SET_LOADING", true);

    try {
      const data = await this.$store.dispatch("gaps/getStatusSummaryReport",  this.reportFilter);
      this.pageRows = data.map(({ Accu,Accu1,Accu2, ...item }) => item);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  get getEntity() {
    return this.$store.state.auth.user.entities.filter(
      (e) => e.id == this.$store.state.auth.entityId
    )[0];
  }

exportExcel() {
  /*const store = this.$store;
  this.$store.commit("main/SET_LOADING", true);*/
  var reportTitle = "STATUS SUMMARY REPORT 2";
  var subtitle = "";
  var fileName = "status_summary_report_" + this.$moment().format("MMDDYYYY_hhmma");
  const reportDate = this.$moment().format("MMM DD YYYY hh:mm A").toUpperCase();
  const reportRangeDate = "";
  const medicalOffice = this.getEntity.name;


  if (!this.pageRows || this.pageRows.length === 0) return;

  const rowHeaders = Object.keys(this.pageRows[0]); 
  const items = this.pageRows; 
  const font = {
    name: "Segoe UI",
    size: 14,
    underline: false,
    bold: true,
    color: { argb: "1E293B" }
  };
  const alignment = {
    vertical: "middle",
    horizontal: "right",
  };

  const workbook = new ExcelJS.Workbook();
  workbook.creator = "PatientCare";
  workbook.lastModifiedBy = "PatientCare";
  workbook.created = new Date();
  workbook.modified = new Date();
  workbook.lastPrinted = new Date();

  const worksheet = workbook.addWorksheet("Report");

  worksheet.getCell("J1").value = reportTitle;
  worksheet.getCell("J2").value = reportDate;
  worksheet.getCell("J3").value = medicalOffice;
  worksheet.getCell("J4").value = reportRangeDate;

  worksheet.mergeCells("J1:K1");
  worksheet.mergeCells("J2:K2");
  worksheet.mergeCells("J3:K3");
  worksheet.mergeCells("J4:K4");

  ["J1", "J2", "J3", "J4"].forEach(cellId => {
    worksheet.getCell(cellId).font = font;
    worksheet.getCell(cellId).alignment = alignment;
  });

  // Add logo
  var img = new Image();
  img.onload = function () {
    var canvas: any = document.createElement("CANVAS");
    var ctx = canvas.getContext("2d");
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(this, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    canvas = null;

    let logo = workbook.addImage({
      base64: dataURL,
      extension: "png",
    });

    worksheet.addImage(logo, "A1:A4");
    worksheet.mergeCells("A1", "A4");

    // Blank Row
    worksheet.addRow([]);

    // Add subtitle separator line
    let subTitleRow = worksheet.addRow([subtitle]);
    worksheet.mergeCells(`A6:${String.fromCharCode(65 + items.length)}6`);

    subTitleRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin", color: { argb: "E2E8F0" } },
      };
    });

    const formattedHeaders = [reportTitle];
    items.forEach((_, index) => {
      if (index === items.length - 1) {
        formattedHeaders.push("Total");
      } else {
        formattedHeaders.push("");
      }
    });

    let headerRow = worksheet.addRow(formattedHeaders);
    headerRow.height = 35;

    headerRow.eachCell((cell, colNumber) => {
      const isFirstColumn = (colNumber === 1);
      const isTotalColumn = (colNumber === formattedHeaders.length);
      
      if (isTotalColumn) {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "0F172A" } };
        cell.font = { name: "Segoe UI", size: 11, color: { argb: "FFFFFF" }, bold: true };
      } else {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };
        cell.font = { name: "Segoe UI", size: 11, color: { argb: "0F172A" }, bold: true };
      }

      cell.alignment = {
        vertical: "middle",
        horizontal: isFirstColumn ? "left" : "right"
      };
    });

    rowHeaders.forEach((headerName: string, rowIndex: number) => {
      const rowData: any[] = [headerName];

      items.forEach((report: any, reportIndex: number) => {
        const isTotalColumn = (reportIndex === items.length - 1);
        
        if (isTotalColumn && (headerName === "Months" || headerName === "Period")) {
          rowData.push("");
        } else {
          const cellValue = report[headerName];
          rowData.push(cellValue !== undefined && cellValue !== null ? cellValue : "-");
        }
      });

      let insertedRow = worksheet.addRow(rowData);
      insertedRow.height = 24;

      const isHighlightedRow = (headerName === "Total Not Contacted" || headerName === "Total Contacted");

      insertedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const isFirstColumn = (colNumber === 1);
        const isTotalColumn = (colNumber === formattedHeaders.length);
        
        let cellBgColor = "FFFFFF";
        if (isHighlightedRow) {
          cellBgColor = isTotalColumn ? "E2E8F0" : "F1F5F9"; 
        }

        cell.fill = { 
          type: "pattern", 
          pattern: "solid", 
          fgColor: { argb: cellBgColor } 
        };
        
        cell.border = { bottom: { style: "thin", color: { argb: "F1F5F9" } } };

        cell.font = {
          name: "Segoe UI",
          size: 10,
          bold: isFirstColumn || isTotalColumn || isHighlightedRow, 
          color: { argb: isTotalColumn ? "000000" : (cell.value === "-" ? "E2E8F0" : "334155") }
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: isFirstColumn ? "left" : "right"
        };
      });
    });

   
    worksheet.columns.forEach((col, idx) => {
      if (idx === 0) {
        col.width = 32; 
      } else if (idx === 9) {
        col.width = 20; 
      } else {
        col.width = 16; 
      }
    });

    const footerFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };

    var emptyRow = worksheet.addRow([]);
    worksheet.mergeCells(`A${emptyRow.number}:K${emptyRow.number}`);

    let footerRow = worksheet.addRow(["service@waitingmed.com · www.waitingmed.com"]);
    footerRow.getCell(1).fill = footerFill;
    worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

    footerRow.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.font = { name: "Segoe UI", size: 10, color: { argb: "64748B" }, bold: false };
    });

    footerRow = worksheet.addRow(["15105 D John Delaney Drive Suite 317,Charlotte NC 28277"]);
    footerRow.getCell(1).fill = footerFill;
    worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

    footerRow.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.font = { name: "Segoe UI", size: 10, color: { argb: "94A3B8" }, bold: false };
    });

    worksheet.addRow([]);

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      var url = window.URL.createObjectURL(blob);
      var doc = document.createElement("a");
      doc.href = url;
      doc.download = fileName + ".xlsx";
      doc.click();
      window.URL.revokeObjectURL(url);
    });
  };

  img.src = require("../assets/wmpc_logo.png");
}


async exportDetailedReport() {
  if (!this.reportFilter.period) {
    return;
  }

  this.$store.commit("main/SET_LOADING", true);

  try {
    const data = await this.$store.dispatch("gaps/getDetailedStatusSummaryReport", this.reportFilter);
    
    if (!data || data.length === 0) {
      return;
    }

    const reportTitle = "DETAILED STATUS SUMMARY REPORT";
    const subtitle = "";
    const fileName = "detailed_status_summary_report_" + this.$moment().format("MMDDYYYY_hhmma");
    const reportDate = this.$moment().format("MMM DD YYYY hh:mm A").toUpperCase();
    const reportRangeDate = ""; 
    const medicalOffice = this.getEntity.name;

    const font = {
      name: "Segoe UI",
      size: 14,
      underline: false,
      bold: true,
      color: { argb: "1E293B" }
    };
    const alignment = {
      vertical: "middle",
      horizontal: "left",
    };

    const workbook = new ExcelJS.Workbook();
    workbook.creator = "PatientCare";
    workbook.lastModifiedBy = "PatientCare";
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();

    const worksheet = workbook.addWorksheet("Detailed Report");

    worksheet.getCell("L1").value = reportTitle;
    worksheet.getCell("L2").value = reportDate;
    worksheet.getCell("L3").value = medicalOffice;
    worksheet.getCell("L4").value = reportRangeDate;

    worksheet.mergeCells("L1:M1");
    worksheet.mergeCells("L2:M2");
    worksheet.mergeCells("L3:M3");
    worksheet.mergeCells("L4:M4");

    ["L1", "L2", "L3", "L4"].forEach(cellId => {
      worksheet.getCell(cellId).font = font;
      worksheet.getCell(cellId).alignment = alignment;
    });

    const self = this; 
    var img = new Image();
    img.onload = function () {
      var canvas: any = document.createElement("CANVAS");
      var ctx = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(this, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      canvas = null;

      let logo = workbook.addImage({
        base64: dataURL,
        extension: "png",
      });

      worksheet.addImage(logo, "A1:A4");
      worksheet.mergeCells("A1", "A4");

      worksheet.addRow([]);

      let subTitleRow = worksheet.addRow([subtitle]);
      worksheet.mergeCells(`A6:M6`); 

      subTitleRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin", color: { argb: "E2E8F0" } },
        };
      });

      const headersMap = [
        { header: "Gap ID", key: "GapID" },
        { header: "First Name", key: "FirstName" },
        { header: "Last Name", key: "LastName" },
        { header: "Measure", key: "Measure" },
        { header: "Reference Date", key: "ReferenceDate" },
        { header: "Gap Status", key: "GapStatus" },    
        { header: "Sub Status", key: "SubStatusName" },
        { header: "Reason", key: "ReasonName" },
        { header: "Gap Created Date", key: "GapCreatedDate" },
        { header: "Gap Last Update", key: "GapLastUpdate" },
        { header: "Log Date", key: "LogDate" },
        { header: "Log Type Name", key: "LogTypeName" },
        { header: "Comment", key: "Comment" }
      ];

      const formattedHeaders = headersMap.map(h => h.header);

      let headerRow = worksheet.addRow(formattedHeaders);
      headerRow.height = 30;

      headerRow.eachCell((cell) => {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "0F172A" } };
        cell.font = { name: "Segoe UI", size: 10, color: { argb: "FFFFFF" }, bold: true };
        cell.alignment = { vertical: "middle", horizontal: "left" };
      });

      data.forEach((rowItem: any) => {
        const rowData = headersMap.map(h => {
          let value = rowItem[h.key];
          
          if (["GapCreatedDate", "GapLastUpdate", "LogDate"].includes(h.key) && value) {
           // return self.$moment(value).format("MM/DD/YYYY hh:mm A");
           return (self as any).$moment(self.getDate(value)).format("MM/DD/YYYY hh:mm A");
          }else if(["ReferenceDate"].includes(h.key) && value){

            return (self as any).$moment(self.getDate(value)).format("MM/DD/YYYY");
          }
          
          return value !== undefined && value !== null ? value : "-";
        });

        let insertedRow = worksheet.addRow(rowData);
        insertedRow.height = 22;

        insertedRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };
          cell.border = { bottom: { style: "thin", color: { argb: "F1F5F9" } } };
          cell.font = { name: "Segoe UI", size: 9, color: { argb: "334155" } };
          cell.alignment = { vertical: "middle", horizontal: "left" };
        });
      });

      worksheet.columns.forEach((col, idx) => {
        let maxLen = 12; 
        col.eachCell({ includeRowValuesOnly: true }, (cell) => {
          if (cell.row > 7 && cell.value) {
            const cellLen = cell.value.toString().length;
            if (cellLen > maxLen) maxLen = cellLen;
          }
        });
        col.width = maxLen + 4; 
      });

      const footerFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };

      var emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:M${emptyRow.number}`);

      let footerRow = worksheet.addRow(["service@waitingmed.com · www.waitingmed.com"]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:M${footerRow.number}`);

      footerRow.eachCell((cell) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.font = { name: "Segoe UI", size: 10, color: { argb: "64748B" }, bold: false };
      });

      footerRow = worksheet.addRow(["15105 D John Delaney Drive Suite 317,Charlotte NC 28277"]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:M${footerRow.number}`);

      footerRow.eachCell((cell) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.font = { name: "Segoe UI", size: 10, color: { argb: "94A3B8" }, bold: false };
      });

      worksheet.addRow([]);

      workbook.xlsx.writeBuffer().then((buffer) => {
        let blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var url = window.URL.createObjectURL(blob);
        var doc = document.createElement("a");
        doc.href = url;
        doc.download = fileName + ".xlsx";
        doc.click();
        window.URL.revokeObjectURL(url);
      });
    };

    img.src = require("../assets/wmpc_logo.png");

  } catch (error) {
    console.error("Error exporting the detailed report:", error);
  } finally {
    this.$store.commit("main/SET_LOADING", false);
  }
}

exportExcelBK20260630() {
  /*const store = this.$store;
  this.$store.commit("main/SET_LOADING", true);*/
  var reportTitle = "STATUS SUMMARY REPORT 2";
  var subtitle = "";
  var fileName = "status_summary_report_" + this.$moment().format("MMDDYYYY_hhmma");
  const reportDate = this.$moment().format("MMM DD YYYY hh:mm A").toUpperCase();
  const reportRangeDate = "";
  const medicalOffice = this.getEntity.name;

  // SEGURIDAD: Si no hay filas de datos, cancelamos para evitar errores
  if (!this.pageRows || this.pageRows.length === 0) return;

  // 1. EXTRAER MÉTRICAS DIRECTAMENTE DE LAS LLAVES DEL PRIMER ITEM DE DATOS
  // Esto garantiza que rowHeaders sea un Array real con ["Months", "Period", "Qty", etc.]
  const rowHeaders = Object.keys(this.pageRows[0]); 
  const items = this.pageRows; // Los datos por columnas (Item 1, Item 2...)

  const font = {
    name: "Segoe UI",
    size: 14,
    underline: false,
    bold: true,
    color: { argb: "1E293B" }
  };
  const alignment = {
    vertical: "middle",
    horizontal: "right",
  };

  // Create workbook and worksheet
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "PatientCare";
  workbook.lastModifiedBy = "PatientCare";
  workbook.created = new Date();
  workbook.modified = new Date();
  workbook.lastPrinted = new Date();

  const worksheet = workbook.addWorksheet("Report");

  // Add Metadata Info Header
  worksheet.getCell("J1").value = reportTitle;
  worksheet.getCell("J2").value = reportDate;
  worksheet.getCell("J3").value = medicalOffice;
  worksheet.getCell("J4").value = reportRangeDate;

  worksheet.mergeCells("J1:K1");
  worksheet.mergeCells("J2:K2");
  worksheet.mergeCells("J3:K3");
  worksheet.mergeCells("J4:K4");

  ["J1", "J2", "J3", "J4"].forEach(cellId => {
    worksheet.getCell(cellId).font = font;
    worksheet.getCell(cellId).alignment = alignment;
  });

  // Add logo
  var img = new Image();
  img.onload = function () {
    var canvas: any = document.createElement("CANVAS");
    var ctx = canvas.getContext("2d");
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(this, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    canvas = null;

    let logo = workbook.addImage({
      base64: dataURL,
      extension: "png",
    });

    worksheet.addImage(logo, "A1:A4");
    worksheet.mergeCells("A1", "A4");

    // Blank Row
    worksheet.addRow([]);

    // Add subtitle separator line
    let subTitleRow = worksheet.addRow([subtitle]);
    worksheet.mergeCells(`A6:${String.fromCharCode(65 + items.length)}6`);

    subTitleRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin", color: { argb: "E2E8F0" } },
      };
    });

    // --- 2. CONSTRUIR ENCABEZADOS HORIZONTALES (Metric, Item 1, Item 2... Total) ---
    const formattedHeaders = [reportTitle];
    items.forEach((_, index) => {
      if (index === items.length - 1) {
        formattedHeaders.push("Total");
      } else {
        /* formattedHeaders.push(`Item ${index + 1}`); */
        formattedHeaders.push("");
      }
    });

    let headerRow = worksheet.addRow(formattedHeaders);
    headerRow.height = 35;

    headerRow.eachCell((cell, colNumber) => {
      const isFirstColumn = (colNumber === 1);
      const isTotalColumn = (colNumber === formattedHeaders.length);
      
      if (isTotalColumn) {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "0F172A" } };
        cell.font = { name: "Segoe UI", size: 11, color: { argb: "FFFFFF" }, bold: true };
      } else {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };
        cell.font = { name: "Segoe UI", size: 11, color: { argb: "0F172A" }, bold: true };
      }

      cell.alignment = {
        vertical: "middle",
        horizontal: isFirstColumn ? "left" : "right"
      };
    });

    // --- 3. CONSTRUIR FILAS VERTICALES MAPEANDO LOS STATUS ---
    rowHeaders.forEach((headerName: string, rowIndex: number) => {
      // Iniciamos la fila con el nombre de la métrica (Columna izquierda)
      const rowData: any[] = [headerName];

      // Iteramos por cada item para extraer el valor exacto que tiene esa métrica
      items.forEach((report: any, reportIndex: number) => {
        const isTotalColumn = (reportIndex === items.length - 1);
        
        // Regla: Si es la columna Total Y es 'Months' o 'Period', forzar vacío
        if (isTotalColumn && (headerName === "Months" || headerName === "Period")) {
          rowData.push("");
        } else {
          // Extraemos el valor del objeto de manera segura
          const cellValue = report[headerName];
          rowData.push(cellValue !== undefined && cellValue !== null ? cellValue : "-");
        }
      });

      // Insertar la fila armada en la hoja de Excel
      let insertedRow = worksheet.addRow(rowData);
      insertedRow.height = 24;

      insertedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const isFirstColumn = (colNumber === 1);
        const isTotalColumn = (colNumber === formattedHeaders.length);
        
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };
        cell.border = { bottom: { style: "thin", color: { argb: "F1F5F9" } } };

        cell.font = {
          name: "Segoe UI",
          size: 10,
          bold: isFirstColumn || isTotalColumn,
          color: { argb: isTotalColumn ? "000000" : (cell.value === "-" ? "E2E8F0" : "334155") }
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: isFirstColumn ? "left" : "right"
        };
      });
    });

    // Ajustar anchos de columnas de manera uniforme
    worksheet.columns.forEach((col, idx) => {
      if (idx === 0) {
        col.width = 32; // Columna de Métricas ancha
      }else if (idx === 9) {
        col.width = 20; // Columnas numéricas
      } else {
        col.width = 16; // Columnas numéricas
      }
    });

    // --- FOOTER SECTION ---
    const footerFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };

    var emptyRow = worksheet.addRow([]);
    worksheet.mergeCells(`A${emptyRow.number}:K${emptyRow.number}`);

    let footerRow = worksheet.addRow(["service@waitingmed.com · www.waitingmed.com"]);
    footerRow.getCell(1).fill = footerFill;
    worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

    footerRow.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.font = { name: "Segoe UI", size: 10, color: { argb: "64748B" }, bold: false };
    });

    footerRow = worksheet.addRow(["15105 D John Delaney Drive Suite 317,Charlotte NC 28277"]);
    footerRow.getCell(1).fill = footerFill;
    worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

    footerRow.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.font = { name: "Segoe UI", size: 10, color: { argb: "94A3B8" }, bold: false };
    });

    worksheet.addRow([]);

    // Guardar archivo Excel
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      var url = window.URL.createObjectURL(blob);
      var doc = document.createElement("a");
      doc.href = url;
      doc.download = fileName + ".xlsx";
      doc.click();
      window.URL.revokeObjectURL(url);
    });
  };

  img.src = require("../assets/wmpc_logo.png");
}
  exportExcelX() {
  /*const store = this.$store;
  this.$store.commit("main/SET_LOADING", true);*/
  var reportTitle = "STATUS SUMMARY REPORT 2";
  var subtitle = "";
  var fileName = "status_summary_report_" + this.$moment().format("MMDDYYYY_hhmma");
  const reportDate = this.$moment().format("MMM DD YYYY hh:mm A").toUpperCase();
  const reportRangeDate = "";
  const medicalOffice = this.getEntity.name;

  // Header keys from the layout
  const header = Object.keys(this.pageRows[0]);
  const font = {
    name: "Segoe UI",
    size: 14,
    underline: false,
    bold: true,
    color: { argb: "1E293B" }
  };
  const alignment = {
    vertical: "middle",
    horizontal: "right",
  };

  // Process rows dynamically mapping data matching visual layout
const data: any[][] = []; // Definimos que data es una matriz de any
for (const item of this.pageRows) {
  var row: any[] = []; // <--- AGREGAR : any[] AQUÍ para solucionar el error

  for (const prop in item) {
    row.push(item[prop]);
  }

  data.push(row);
}


  // Create workbook and worksheet
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "PatientCare";
  workbook.lastModifiedBy = "PatientCare";
  workbook.created = new Date();
  workbook.modified = new Date();
  workbook.lastPrinted = new Date();

  const worksheet = workbook.addWorksheet("Report");

  // Add Metadata Info Header
  worksheet.getCell("J1").value = reportTitle;
  worksheet.getCell("J2").value = reportDate;
  worksheet.getCell("J3").value = medicalOffice;
  worksheet.getCell("J4").value = reportRangeDate;

  worksheet.mergeCells("J1:K1");
  worksheet.mergeCells("J2:K2");
  worksheet.mergeCells("J3:K3");
  worksheet.mergeCells("J4:K4");

  ["J1", "J2", "J3", "J4"].forEach(cellId => {
    worksheet.getCell(cellId).font = font;
    worksheet.getCell(cellId).alignment = alignment;
  });

  // Add logo
  var img = new Image();
  img.onload = function () {
    var canvas: any = document.createElement("CANVAS");
      var ctx = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(this, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      canvas = null;

    let logo = workbook.addImage({
      base64: dataURL,
      extension: "png",
    });

    worksheet.addImage(logo, "A1:A4");
    worksheet.mergeCells("A1", "A4");

    // Blank Row
    worksheet.addRow([]);

    // Add subtitle separator line
    let subTitleRow = worksheet.addRow([subtitle]);
    worksheet.mergeCells(`A6:${String.fromCharCode(65 + header.length - 1)}6`);

    subTitleRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin", color: { argb: "E2E8F0" } },
      };
    });

    // --- ADD THE CORE HEADER ROW ---
    // Map headers to display professional naming (Item 1, Item 2... Total)
    const formattedHeaders = header.map((h, index) => {
      if (index === 0) return "Metric / Report";
      if (index === header.length - 1) return "Total";
      return `Item ${index}`;
    });

    let headerRow = worksheet.addRow(formattedHeaders);
    headerRow.height = 26;

    headerRow.eachCell((cell, colNumber) => {
      const isTotalColumn = (colNumber === header.length);
      
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: isTotalColumn ? "0F172A" : "1E293B" }, // Distinct darker tone for total header
      };
      cell.border = {
        top: { style: "thin", color: { argb: "1E293B" } },
        left: { style: "thin", color: { argb: "334155" } },
        bottom: { style: "thin", color: { argb: "1E293B" } },
        right: { style: "thin", color: { argb: "334155" } },
      };
      cell.font = {
        name: "Segoe UI",
        size: 11,
        color: { argb: "FFFFFF" },
        bold: true,
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: colNumber === 1 ? "left" : "right"
      };
    });

    // --- ADD DATA ROWS AND APPLY DYNAMIC FORMATTING ---
    data.forEach((rowData, rowIndex) => {
      // Find row metric key name (e.g., 'Months', 'Period', 'Qty')
      const currentMetricName = rowData[0]; 
      
      // Clear redundant entries in the Total column before inserting row
      // If row corresponds to Months or Period, Total column data is erased completely
      if (currentMetricName === "Months" || currentMetricName === "Period") {
        rowData[rowData.length - 1] = ""; 
      }

      let insertedRow = worksheet.addRow(rowData);
      insertedRow.height = 22;

      // Dynamic styling per cell inside the row
      insertedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const isFirstColumn = (colNumber === 1);
        const isTotalColumn = (colNumber === header.length);
        const isEvenRow = (rowIndex % 2 === 1); // Alternating rows logic
        
        // Base zebra or standard background structure
        let cellBgColor = isEvenRow ? "F8FAFC" : "FFFFFF";
        
        // Total column custom light overlay background
        if (isTotalColumn) {
          cellBgColor = "F1F5F9"; 
        }

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: cellBgColor }
        };

        cell.border = {
          bottom: { style: "thin", color: { argb: "E2E8F0" } },
          left: isTotalColumn ? { style: "thin", color: { argb: "CBD5E1" } } : { style: "thin", color: { argb: "F1F5F9" } },
          right: isTotalColumn ? { style: "thin", color: { argb: "CBD5E1" } } : { style: "thin", color: { argb: "F1F5F9" } },
        };

        // Text typography formatting rules
        cell.font = {
          name: "Segoe UI",
          size: 10,
          bold: isFirstColumn || isTotalColumn,
          color: { argb: isTotalColumn ? "000000" : (cell.value === "-" ? "94A3B8" : "334155") }
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: isFirstColumn ? "left" : "right"
        };
      });
    });

    // Column Width Layout Engine Configuration
    worksheet.columns.forEach((col, idx) => {
      if (idx === 0) {
        col.width = 28; // Standardized clean width for metric text titles
      } else {
        col.width = 15; // Structured proportional sizes for items/total cells
      }
    });

    // --- FOOTER SECTION ---
    const footerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFFF" },
    };

    var emptyRow = worksheet.addRow([]);
    worksheet.mergeCells(`A${emptyRow.number}:K${emptyRow.number}`);

    let footerRow = worksheet.addRow(["service@waitingmed.com · www.waitingmed.com"]);
    footerRow.getCell(1).fill = footerFill;
    worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

    footerRow.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.font = { name: "Segoe UI", size: 10, color: { argb: "64748B" }, bold: false };
    });

    footerRow = worksheet.addRow(["Calle Luis Pales Matos FF-15, Levittown, PR 00949"]);
    footerRow.getCell(1).fill = footerFill;
    worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

    footerRow.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.font = { name: "Segoe UI", size: 10, color: { argb: "94A3B8" }, bold: false };
    });

    worksheet.addRow([]);

    // Save/Download Execution
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      var url = window.URL.createObjectURL(blob);
      var doc = document.createElement("a");
      doc.href = url;
      doc.download = fileName + ".xlsx";
      doc.click();
      window.URL.revokeObjectURL(url);
    });
  };

  img.src = require("../assets/wmpc_logo.png");
}

  exportExcelBK() {
    /*const store = this.$store;
    this.$store.commit("main/SET_LOADING", true);*/
    var reportTitle = "STATUS SUMMARY REPORT 2";
    var subtitle = "";
    var fileName =
      "status_summary_report_" + this.$moment().format("MMDDYYYY_hhmma");
    const reportDate = this.$moment()
      .format("MMM DD YYYY hh:mm A")
      .toUpperCase();
    const reportRangeDate = "";
    const medicalOffice = this.getEntity.name;

    const header = Object.keys(this.pageRows[0]);
    const font = {
      name: "Calibri",
      family: 2,
      size: 16,
      underline: false,
      bold: true,
    };
    const alignment = {
      vertical: "middle",
      horizontal: "right",
    };
    const data: any = [];
    var total = 0;
    const moment: any = this.$moment;
    for (const item of this.pageRows) {
      var row: any = [];

      for (const prop in item) row.push(item[prop]);

      data.push(row);
    }

    //const totals = this.pageRows.map((i) => i.Total).reduce((accumulator, value) => accumulator + value, 0);

    //Create workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "PatientCare";
    workbook.lastModifiedBy = "PatientCare";
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();

    const worksheet = workbook.addWorksheet("Report");

    //Add Row and formatting
    let reportTitleRow = (worksheet.getCell("J1").value = reportTitle);
    let reportDateRow = (worksheet.getCell("J2").value = reportDate);
    let medicalOfficeRow = (worksheet.getCell("J3").value = medicalOffice);
    let reportRangeDateRow = (worksheet.getCell("J4").value = reportRangeDate);

    // Set font, size and style in title row.
    worksheet.mergeCells("J1:K1");
    worksheet.mergeCells("J2:K2");
    worksheet.mergeCells("J3:K3");
    worksheet.mergeCells("J4:K4");

    worksheet.getCell("J1").font = font;
    worksheet.getCell("J2").font = font;
    worksheet.getCell("J3").font = font;
    worksheet.getCell("J4").font = font;

    worksheet.getCell("J1").alignment = alignment;
    worksheet.getCell("J2").alignment = alignment;
    worksheet.getCell("J3").alignment = alignment;
    worksheet.getCell("J4").alignment = alignment;

    //Add logo
    var img = new Image();

    img.onload = function () {
      var canvas: any = document.createElement("CANVAS");
      var ctx = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(this, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      canvas = null;

      //Add Image
      let logo = workbook.addImage({
        base64: dataURL,
        extension: "png",
      });

      /* worksheet.addImage(logo, "A1:B4");
      worksheet.mergeCells("A1", "B4");*/
      worksheet.addImage(logo, "A1:A4");
      worksheet.mergeCells("A1", "A4");

      // Blank Row
      worksheet.addRow([]);

      //Add waitingList row
      let subTitleRow = worksheet.addRow([subtitle]); //subtitle
      worksheet.mergeCells("A6:I6");

      subTitleRow.eachCell((cell, number) => {
        cell.border = {
          top: {
            style: "thin",
            color: {
              argb: "87CEEB",
            },
          },
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 14,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "87CEEB",
          },
          bgColor: {
            argb: "FFFFFF",
          },
        };
        cell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //add data
      worksheet.addRows(data);

      //column width
      worksheet.getColumn(1).width = 60;
      worksheet.getColumn(2).width = 16;
      worksheet.getColumn(3).width = 16;
      worksheet.getColumn(4).width = 16;
      worksheet.getColumn(5).width = 16;
      worksheet.getColumn(6).width = 16;
      worksheet.getColumn(7).width = 16;
      worksheet.getColumn(8).width = 16;
      worksheet.getColumn(9).width = 16;
      worksheet.getColumn(10).width = 16;
      worksheet.getColumn(11).width = 16;
      worksheet.getColumn(12).width = 16;
      worksheet.getColumn(13).width = 16;
      worksheet.getColumn(14).width = 16;
      worksheet.getColumn(15).width = 16;
      worksheet.getColumn(16).width = 16;
      worksheet.getColumn(17).width = 16;

      //Footer Row
      const footerFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FFFFFF",
        },
      };

      var emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:K${emptyRow.number}`);

      let footerRow = worksheet.addRow([
        "service@waitingmed.com · www.waitingmed.com",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "Calle Luis Pales Matos FF-15, Levittown, PR 00949",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:K${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:K${emptyRow.number}`);
      //save
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //app.saveAs(blob, fileName + '.xlsx');
        var url = window.URL.createObjectURL(blob);

        var doc = document.createElement("a");
        doc.href = url;
        doc.download = fileName + ".xlsx";
        doc.click();
        window.URL.revokeObjectURL(url);
      });
    };

    img.src = require("../assets/wmpc_logo.png");
  }

  clearFilter() {
    this.reportFilter = this.defaultFilter();
    this.$store.commit("gaps/RESET_FILTER");
    this.getReport();
  }

  mounted() {
    //this.filter = this.defaultFilter();
    this.getReport();
  }
}
